import { BookOpenCheckIcon, CalendarCheckIcon, FileTextIcon, FolderOpenIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '150 Teaching Activities & Challenges',
    description: 'Ready-to-use activities covering all topics, organized by difficulty.',
    icon: FolderOpenIcon,
  },
  {
    number: '2',
    title: 'Assessment Resource Pack',
    description: '125 assessment items, answer keys, grading criteria, feedback guidance.',
    icon: ListChecksIcon,
  },
  {
    number: '3',
    title: '100 Real-World Case Studies',
    description: 'Circuits, transformers, motors, power generation, installations, industrial control scenarios.',
    icon: FileTextIcon,
  },
  {
    number: '4',
    title: 'Dictionary: 200 Essential Terms',
    description: 'Complete reference handbook for electrical engineering terminology.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '5',
    title: 'Lesson Planning Guide',
    description: '14 detailed lesson examples, instructional sequences, assessment strategies.',
    icon: CalendarCheckIcon,
  },
];
